// Global header interactivity: mega menus, mobile drawer, search modal.
// Vanilla JS (no jQuery needed) — runs on every page, not just the homepage.

function initMegaMenus(header) {
    const triggers = header.querySelectorAll('[data-mega-trigger]');
    const navRow = header.querySelector('.header__nav-row');
    const backdrop = header.querySelector('[data-mega-backdrop]');
    if (!triggers.length || !navRow) return;

    function closeAll() {
        triggers.forEach((t) => t.setAttribute('aria-expanded', 'false'));
        header.querySelectorAll('[data-mega-panel]').forEach((p) => p.classList.remove('header__mega--active'));
        if (backdrop) backdrop.classList.remove('header__mega-backdrop--active');
    }

    function open(name) {
        closeAll();
        const panel = header.querySelector(`[data-mega-panel="${name}"]`);
        const trigger = header.querySelector(`[data-mega-trigger="${name}"]`);
        if (panel) panel.classList.add('header__mega--active');
        if (trigger) trigger.setAttribute('aria-expanded', 'true');
        // On short pages (e.g. thank-you) the panel can be taller than the
        // content sitting below it in normal flow — since it's positioned
        // absolute, that content doesn't get pushed down and peeks out from
        // under the panel. Dim it with a backdrop instead of leaving it bare.
        if (backdrop) backdrop.classList.add('header__mega-backdrop--active');
    }

    triggers.forEach((trigger) => {
        const name = trigger.getAttribute('data-mega-trigger');
        trigger.addEventListener('mouseenter', () => open(name));
        trigger.addEventListener('click', () => {
            const isOpen = trigger.getAttribute('aria-expanded') === 'true';
            isOpen ? closeAll() : open(name);
        });
    });

    header.querySelectorAll('[data-mega-panel]').forEach((panel) => {
        panel.addEventListener('mouseleave', closeAll);
    });

    // Sliding from a trigger onto a plain link (e.g. "New In") never enters
    // the panel, so its mouseleave can't fire — close on the link instead.
    navRow.querySelectorAll('.header__nav-link:not([data-mega-trigger])').forEach((link) => {
        link.addEventListener('mouseenter', closeAll);
    });

    if (backdrop) backdrop.addEventListener('click', closeAll);

    document.addEventListener('click', (e) => {
        if (!navRow.contains(e.target)) closeAll();
    });
}

function initDrawer(header) {
    const drawer = header.querySelector('[data-header-drawer]');
    if (!drawer) return;
    const openBtns = header.querySelectorAll('[data-header-drawer-open]');
    const closeBtns = drawer.querySelectorAll('[data-header-drawer-close]');
    const sectionBtns = drawer.querySelectorAll('[data-drawer-section]');
    const backBtns = drawer.querySelectorAll('[data-drawer-back]');
    const nav = drawer.querySelector('.header__drawer-nav');

    function openDrawer() {
        drawer.classList.add('header__drawer--active');
        document.body.classList.add('no-scroll');
    }
    function closeDrawer() {
        drawer.classList.remove('header__drawer--active');
        document.body.classList.remove('no-scroll');
        drawer.querySelectorAll('[data-drawer-panel]').forEach((p) => p.classList.remove('header__drawer-sub--active'));
        if (nav) nav.classList.remove('header__drawer-nav--hidden');
    }

    openBtns.forEach((btn) => btn.addEventListener('click', openDrawer));
    closeBtns.forEach((btn) => btn.addEventListener('click', closeDrawer));

    sectionBtns.forEach((btn) => {
        btn.addEventListener('click', () => {
            const name = btn.getAttribute('data-drawer-section');
            const panel = drawer.querySelector(`[data-drawer-panel="${name}"]`);
            if (panel) panel.classList.add('header__drawer-sub--active');
            if (nav) nav.classList.add('header__drawer-nav--hidden');
        });
    });

    backBtns.forEach((btn) => {
        btn.addEventListener('click', () => {
            drawer.querySelectorAll('[data-drawer-panel]').forEach((p) => p.classList.remove('header__drawer-sub--active'));
            if (nav) nav.classList.remove('header__drawer-nav--hidden');
        });
    });

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') closeDrawer();
    });
}

function initSearchModal(header) {
    const modal = header.querySelector('[data-header-search-modal]');
    if (!modal) return;
    const openBtns = header.querySelectorAll('[data-header-search-open]');
    const closeBtns = modal.querySelectorAll('[data-header-search-close]');

    openBtns.forEach((btn) => btn.addEventListener('click', () => modal.classList.add('header__search-modal--active')));
    closeBtns.forEach((btn) => btn.addEventListener('click', () => modal.classList.remove('header__search-modal--active')));

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') modal.classList.remove('header__search-modal--active');
    });
}

// --fc-header-h: the sticky header's live height, for anything that sticks
// right below it (product gallery, bundle picker bar). It differs per
// breakpoint and with the promo text wrapping, so no fixed number fits.
function trackHeight(header) {
    const set = () => document.documentElement.style.setProperty('--fc-header-h', `${Math.round(header.getBoundingClientRect().height)}px`);
    set();
    if (window.ResizeObserver) new ResizeObserver(set).observe(header);
    else window.addEventListener('resize', set);
}

function init() {
    const header = document.getElementById('site-header');
    if (!header) return;
    trackHeight(header);
    initMegaMenus(header);
    initDrawer(header);
    initSearchModal(header);
}

export default { init };
